import { z } from 'zod'

const STORAGE_KEY = 'gecko_doc_nav_metadata_scope:v1'

export const metadataScopeSchema = z.enum(['doc', 'page'])
export type MetadataScope = z.infer<typeof metadataScopeSchema>

export function readMetadataScopePreference(): MetadataScope | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw === null) return null
    const result = metadataScopeSchema.safeParse(raw)
    return result.success ? result.data : null
  } catch {
    return null
  }
}

export function writeMetadataScopePreference(scope: MetadataScope): void {
  try {
    localStorage.setItem(STORAGE_KEY, scope)
  } catch {
    /* localStorage unavailable */
  }
}
